import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import PaymentPage from './PaymentPage.js';

export default WithGASetup(PaymentPage, AuthContext);
